// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.page_main__NOXsH {
  overflow: hidden;
}

.page_extra_row__GOk-m {
  padding: 200px 50px;
  display: flex;
  column-gap: 5vw;
  align-items: center;
  justify-content: space-between;
  border-bottom: 2px solid #EEEEEE;
}
.page_extra_row_leftSide__-LzXB {
  display: flex;
  align-items: center;
  column-gap: 24px;
}
.page_extra_row_leftSide__-LzXB p {
  font-weight: 400;
  font-size: 20.85px;
  line-height: 23.8px;
}
.page_extra_row_rightSide__qbome {
  font-size: 36px;
  line-height: 44px;
  text-transform: uppercase;
  font-weight: 500;
}

.page_cvetochek__8aV7s {
  position: absolute;
  top: -50%;
  right: 40%;
  z-index: 1;
}

.page_cvetochek2__-j-PL {
  position: absolute;
  z-index: 1;
  right: 0;
}

.page_frame55__\\+yB1u {
  display: none;
}

.page_first_row__zWz7E {
  background-color: #3D9246;
  height: 1024px;
  z-index: 1;
}
.page_first_row_content__LOeo\\+ {
  margin: 0 auto;
  max-width: 1440px;
  height: 100%;
  position: relative;
  z-index: 2;
  padding: 80px 40px 0 50px;
}

.page_girls_reading__CD2dB {
  position: absolute;
  right: 0;
}

.page_tamyr__loepg {
  position: absolute;
  top: 200px;
}
.page_tamyr_emblems__Vk9q\\+ img {
  margin-right: 34px;
}
.page_tamyr_title__Zg2Kz {
  max-width: 821px;
  margin-top: 60px;
  color: #FFFFFF;
  font-size: 48px;
  line-height: 57px;
  text-transform: uppercase;
  font-weight: 500;
}
.page_tamyr_button__EiHEL {
  margin-top: 60px;
  cursor: pointer;
}

.page_mosque__OKjgY {
  position: absolute;
  bottom: 80px;
  right: 452px;
}

.page_moon__WUBfS {
  border-radius: 25px;
  width: 345px;
  height: 345px;
  padding: 6px 3px 3px 3px;
  background-color: #FFB765;
  position: absolute;
  bottom: -120px;
  right: 0;
}
.page_moon__WUBfS img {
  object-fit: cover;
  object-position: 50%;
  border-radius: 25px;
  width: 100%;
  height: 100%;
}

.page_second_row__YJM3x {
  background-color: white;
  height: 865px;
  position: relative;
  z-index: 2;
}
.page_second_row_content__YbDli {
  max-width: 1440px;
  margin: 0 auto;
  height: 100%;
  position: relative;
}
.page_second_row_image__XGW8C {
  position: absolute;
  bottom: 0;
  right: 55%;
}
.page_second_row_info__XVEpP {
  position: absolute;
  width: 621px;
  height: 390px;
  right: 50px;
  top: 238px;
}
.page_second_row_info__XVEpP > h1 {
  font-size: 36px;
  line-height: 44px;
  text-transform: uppercase;
}
.page_second_row_info__XVEpP > p {
  margin-top: 20px;
  line-height: 22px;
  font-size: 18px;
}
.page_second_row_info__XVEpP .page_download__qdOHL {
  margin-top: 56px;
  display: flex;
  align-items: center;
}
.page_second_row_info__XVEpP .page_download_line__eP9zR {
  flex: 1 1;
  height: 1px;
  background-color: #CACACA;
}
.page_second_row_info__XVEpP .page_download_sign__vjWIL {
  margin: 0 25px;
  font-weight: 500;
}
.page_second_row_info__XVEpP .page_buttons__wvcaR {
  display: flex;
  margin-top: 56px;
  justify-content: space-between;
}
.page_second_row_info__XVEpP .page_buttons_button__tix-b {
  width: 100%;
  margin-right: 20px;
  border-radius: 12px;
  background-color: #3D9246;
  padding: 11px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.page_third_row__4Gs07 {
  background-color: #3D9246;
  height: 557px;
  z-index: 1;
}
.page_third_row_content__0oFBD {
  margin: 0 auto;
  max-width: 1440px;
  height: 100%;
  position: relative;
  padding: 93px 50px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  z-index: 2;
}

.page_about__A6lpY {
  width: 620px;
  color: white;
}
.page_about__A6lpY > h1 {
  font-size: 36px;
  text-transform: uppercase;
  font-weight: 500;
}
.page_about__A6lpY > p {
  font-size: 18px;
  line-height: 22px;
  margin-top: 20px;
}

.page_fourth_row__Yvg99 {
  height: 561px;
  background-color: white;
}
.page_fourth_row_content__OlBYY {
  margin: 0 auto;
  max-width: 1440px;
  height: 100%;
  padding: 55px 50px;
  display: flex;
  justify-content: space-between;
}
.page_fourth_row_content__OlBYY > div {
  display: flex;
  flex-direction: column;
  justify-content: space-between;
}

.page_contacts__-oWcx {
  font-weight: 500;
}
.page_contacts_header__Ytwh4 {
  font-size: 24px;
}
.page_contacts_content__-BU8P {
  margin-top: 20px;
}

.page_write_us__y39UB {
  width: 445px;
}
.page_write_us_1strow__vagMP {
  font-weight: 500;
}
.page_write_us_1strow_header__DFdV6 {
  font-size: 24px;
}
.page_write_us_1strow_sign__EapqV {
  margin-top: 20px;
}
.page_write_us_form_mail__IMpcB {
  width: 100%;
  outline: none;
  padding: 20px;
  margin-bottom: 8px;
  border: none;
  background-color: #EEEEEE;
  border-radius: 12px;
  color: #575757;
  font-weight: 500;
  font-size: 18px;
  line-height: 22px;
}
.page_write_us_form_message__lN2Wh {
  width: 100%;
  outline: none;
  padding: 20px;
  border: none;
  resize: none;
  background-color: #EEEEEE;
  border-radius: 12px;
  height: 168px;
  max-height: 168px;
  min-height: 168px;
  max-width: 100%;
  min-width: 100%;
  color: #575757;
  font-weight: 500;
  font-family: Roboto, sans-serif;
  font-size: 18px;
  line-height: 22px;
}

.page_send_button__ciNME {
  margin: 0 auto;
  width: 278px;
  height: 56px;
  cursor: pointer;
}

@media screen and (max-width: 1400px) {
  .page_first_row_content__LOeo\\+ {
    display: flex;
    padding: 80px 20px 0 25px;
  }
  .page_first_row__zWz7E .page_tamyr__loepg {
    position: static;
    max-width: 800px;
    margin-top: 100px;
  }
  .page_first_row__zWz7E .page_tamyr_emblems__Vk9q\\+ img {
    margin-right: 34px;
  }
  .page_first_row__zWz7E .page_tamyr_title__Zg2Kz {
    margin-top: 60px;
    color: #FFFFFF;
    font-size: 40px;
    line-height: 57px;
    text-transform: uppercase;
    font-weight: 500;
  }
  .page_first_row__zWz7E .page_tamyr_button__EiHEL {
    margin-top: 60px;
    cursor: pointer;
  }
  .page_girls_reading__CD2dB {
    position: static;
  }
}
@media screen and (max-width: 1300px) {
  .page_second_row_content__YbDli {
    max-width: 1300px;
  }
  .page_second_row_info__XVEpP {
    position: absolute;
    width: 500px;
    height: 300px;
    right: 50px;
    top: 208px;
  }
  .page_second_row_info__XVEpP > h1 {
    font-size: 30px;
    line-height: 40px;
    text-transform: uppercase;
  }
  .page_second_row_info__XVEpP > p {
    margin-top: 15px;
    line-height: 20px;
    font-size: 16px;
  }
  .page_second_row_info__XVEpP .page_download__qdOHL {
    margin-top: 50px;
    display: flex;
    align-items: center;
  }
  .page_second_row_info__XVEpP .page_download_line__eP9zR {
    flex: 1 1;
    height: 1px;
    background-color: #CACACA;
  }
  .page_second_row_info__XVEpP .page_download_sign__vjWIL {
    margin: 0 20px;
    font-weight: 500;
  }
  .page_second_row_info__XVEpP .page_buttons__wvcaR {
    display: flex;
    margin-top: 40px;
    justify-content: space-between;
  }
  .page_second_row_info__XVEpP .page_buttons_button__tix-b {
    border-radius: 12px;
    background-color: #3D9246;
    padding: 3px 57px;
    cursor: pointer;
  }
}
@media screen and (max-width: 1100px) {
  .page_extra_row__GOk-m {
    padding: 140px 42px;
  }
  .page_extra_row_leftSide__-LzXB {
    column-gap: 16px;
  }
  .page_extra_row_leftSide__-LzXB img {
    width: 76px;
    height: 80px;
  }
  .page_extra_row_leftSide__-LzXB p {
    font-size: 14px;
    line-height: 16px;
  }
  .page_extra_row_rightSide__qbome {
    font-size: 24px;
    line-height: 28px;
  }
  .page_first_row_content__LOeo\\+ {
    display: flex;
    padding: 40px 20px 0 25px;
  }
  .page_first_row__zWz7E .page_tamyr__loepg {
    position: static;
    max-width: 700px;
    margin-top: 100px;
  }
  .page_first_row__zWz7E .page_tamyr_emblems__Vk9q\\+ img {
    margin-right: 34px;
  }
  .page_first_row__zWz7E .page_tamyr_title__Zg2Kz {
    font-size: 36px;
    line-height: 44px;
  }
  .page_girls_reading__CD2dB {
    position: static;
  }
  .page_girls_reading__CD2dB img {
    width: 450px;
  }
  .page_mosque__OKjgY {
    right: 100px;
  }
  .page_moon__WUBfS {
    display: none;
  }
  .page_second_row__YJM3x {
    height: 650px;
  }
  .page_second_row_content__YbDli {
    max-width: 1100px;
  }
  .page_second_row_image__XGW8C {
    position: absolute;
    bottom: 0;
    right: 60%;
    height: 700px;
  }
  .page_second_row_info__XVEpP {
    position: absolute;
    width: 500px;
    height: 300px;
    right: 30px;
    top: 150px;
  }
  .page_second_row_info__XVEpP > h1 {
    font-size: 24px;
    line-height: 35px;
    text-transform: uppercase;
  }
  .page_second_row_info__XVEpP > p {
    margin-top: 15px;
    line-height: 18px;
    font-size: 14px;
  }
}
@media screen and (max-width: 957px) {
  .page_first_row__zWz7E {
    height: 800px;
  }
  .page_first_row_content__LOeo\\+ {
    max-width: 957px;
    padding: 40px 15px 0 20px;
  }
  .page_first_row__zWz7E .page_tamyr__loepg {
    position: static;
    max-width: 500px;
    margin-top: 100px;
  }
  .page_first_row__zWz7E .page_tamyr_emblems__Vk9q\\+ img {
    margin-right: 24px;
    width: 130px;
  }
  .page_first_row__zWz7E .page_tamyr_title__Zg2Kz {
    font-size: 26px;
    line-height: 36px;
  }
  .page_first_row__zWz7E .page_girls_reading__CD2dB img {
    width: 400px;
  }
  .page_first_row__zWz7E .page_mosque__OKjgY {
    bottom: 30px;
  }
  .page_second_row__YJM3x {
    height: 500px;
  }
  .page_second_row_content__YbDli {
    max-width: 957px;
  }
  .page_second_row_image__XGW8C {
    position: absolute;
    bottom: 0;
    right: 60%;
    height: 550px;
  }
  .page_second_row_info__XVEpP {
    position: absolute;
    width: 450px;
    height: 300px;
    right: 10px;
    top: 100px;
  }
  .page_second_row_info__XVEpP > h1 {
    font-size: 24px;
    line-height: 35px;
    text-transform: uppercase;
  }
  .page_second_row_info__XVEpP > p {
    margin-top: 15px;
    line-height: 18px;
    font-size: 14px;
  }
  .page_second_row_info__XVEpP .page_buttons__wvcaR {
    display: flex;
    margin-top: 40px;
    justify-content: center;
  }
  .page_second_row_info__XVEpP .page_buttons_button__tix-b {
    border-radius: 10px;
    background-color: #3D9246;
    padding: 0 5vw;
    cursor: pointer;
    margin-right: 1vw;
  }
}
@media screen and (max-width: 805px) {
  .page_extra_row__GOk-m {
    padding: 80px 40px;
    flex-direction: column-reverse;
    column-gap: 0;
    row-gap: 32px;
  }
  .page_extra_row_leftSide__-LzXB p {
    font-size: 16px;
    line-height: 20px;
  }
  .page_second_row__YJM3x {
    height: 450px;
  }
  .page_second_row_image__XGW8C {
    display: none;
  }
  .page_second_row_info__XVEpP {
    width: 100%;
    right: 0;
    padding: 0 30px;
  }
  .page_second_row_info__XVEpP > h1 {
    text-align: center;
  }
  .page_second_row_info__XVEpP > p {
    text-align: center;
  }
}
@media screen and (max-width: 600px) {
  .page_extra_row__GOk-m {
    padding: 48px 23px;
    flex-direction: column-reverse;
    column-gap: 0;
    row-gap: 16px;
  }
  .page_extra_row_leftSide__-LzXB p {
    font-size: 12px;
    line-height: 14px;
  }
  .page_extra_row_rightSide__qbome {
    font-size: 20px;
    line-height: 24px;
  }
  .page_first_row__zWz7E {
    height: 677px;
  }
  .page_first_row_content__LOeo\\+ {
    width: 100%;
    padding: 48px 20px;
  }
  .page_first_row__zWz7E .page_tamyr__loepg {
    position: static;
    max-width: 100%;
    margin-top: 0;
  }
  .page_first_row__zWz7E .page_tamyr_emblems__Vk9q\\+ img {
    width: 78px;
    height: 78px;
    margin-right: 5px;
  }
  .page_first_row__zWz7E .page_tamyr_title__Zg2Kz {
    margin-top: 24px;
    font-size: 7vw;
    line-height: 28px;
    width: 100%;
  }
  .page_first_row__zWz7E .page_tamyr_button__EiHEL {
    margin-top: 24px;
    cursor: pointer;
    width: 201px;
    height: 36px;
  }
  .page_girls_reading__CD2dB {
    position: absolute;
    width: 204px;
    height: 204px;
    left: 20px;
    bottom: 100px;
  }
  .page_girls_reading__CD2dB img {
    max-width: 204px;
    height: 204px;
  }
  .page_moon__WUBfS {
    display: block;
    position: absolute;
    border-radius: 8px;
    padding: 4px 2px 2px 2px;
    width: 150px;
    height: 150px;
    top: 70%;
    right: -70px;
  }
  .page_moon__WUBfS img {
    border-radius: 8px;
  }
  .page_mosque__OKjgY {
    position: absolute;
    right: -45px;
    top: 45%;
    height: 142px;
    width: 142px;
  }
  .page_mosque__OKjgY img {
    width: 142px;
    height: 142px;
  }
  .page_frame55_wrapper__5nwxc {
    position: relative;
    height: 400px;
    width: 100%;
  }
  .page_frame55__\\+yB1u {
    display: block;
    position: absolute;
    border-radius: 20px 20px 0 0;
    top: -15px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  .page_second_row__YJM3x {
    height: 890px;
    max-width: 100vw;
    position: relative;
  }
  .page_second_row_image__XGW8C {
    width: 100%;
  }
  .page_second_row_content__YbDli {
    width: 100%;
    height: 100%;
  }
  .page_second_row_info__XVEpP {
    margin-top: 30px;
    position: static;
    padding: 0 20px;
    height: 490px;
  }
  .page_second_row_info__XVEpP h1 {
    font-weight: 500;
    font-size: 20px;
    line-height: 24px;
    text-align: left;
  }
  .page_second_row_info__XVEpP p {
    color: black;
    font-weight: 400;
    font-size: 16px;
    margin-top: 12px;
    line-height: 20px;
    text-align: left;
  }
  .page_second_row_info__XVEpP .page_buttons__wvcaR {
    display: flex;
    flex-direction: column;
    justify-content: center;
    margin-top: 30px;
  }
  .page_second_row_info__XVEpP .page_buttons_button__tix-b {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 11px;
    margin-top: 6px;
    border-radius: 12px;
    background-color: #3D9246;
    cursor: pointer;
  }
  .page_third_row__4Gs07 {
    height: 600px;
  }
  .page_third_row_content__0oFBD {
    height: 100%;
    max-width: 375px;
    flex-direction: column-reverse;
    padding: 48px 20px;
  }
  .page_third_row_content__0oFBD .page_image__GzZGF img {
    width: 162px;
    height: 162px;
  }
  .page_third_row__4Gs07 .page_about__A6lpY {
    width: 100%;
    margin-top: 25px;
  }
  .page_third_row__4Gs07 .page_about__A6lpY > h1 {
    font-size: 20px;
    line-height: 24px;
    text-transform: uppercase;
    font-weight: 500;
  }
  .page_third_row__4Gs07 .page_about__A6lpY > p {
    font-size: 16px;
    line-height: 20px;
    margin-top: 10px;
  }
  .page_fourth_row__Yvg99 {
    height: 766px;
  }
  .page_fourth_row_content__OlBYY {
    max-width: 375px;
    padding: 48px 20px;
    flex-direction: column-reverse;
  }
  .page_contacts__-oWcx {
    margin-top: 48px;
    margin-bottom: 24px;
  }
  .page_contacts_header__Ytwh4 {
    text-transform: uppercase;
    font-size: 20px;
    line-height: 24px;
    font-weight: 500;
  }
  .page_write_us__y39UB {
    width: 100%;
  }
  .page_write_us_1strow__vagMP {
    font-weight: 500;
  }
  .page_write_us_1strow_header__DFdV6 {
    font-size: 20px;
    line-height: 24px;
    text-transform: uppercase;
  }
  .page_write_us_1strow_sign__EapqV {
    margin-top: 12px;
    font-size: 16px;
    line-height: 20px;
  }
  .page_write_us_form__hoAqh {
    margin-top: 24px;
  }
  .page_write_us__y39UB .page_send_button__ciNME {
    max-width: 181px;
    height: 36px;
    margin-top: 24px;
  }
}`, "",{"version":3,"sources":["webpack://./src/page.module.scss"],"names":[],"mappings":"AAAA;EACE,gBAAA;AACF;;AAEA;EACE,mBAAA;EACA,aAAA;EACA,eAAA;EACA,mBAAA;EACA,8BAAA;EACA,gCAAA;AACF;AAAE;EACE,aAAA;EACA,mBAAA;EACA,gBAAA;AAEJ;AADI;EACE,gBAAA;EACA,kBAAA;EACA,mBAAA;AAGN;AAAE;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;EACA,QAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,cAAA;EACA,UAAA;AACF;AAAE;EACE,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,UAAA;EACA,yBAAA;AAEJ;;AAEA;EACE,kBAAA;EACA,QAAA;AACF;;AAEA;EACE,kBAAA;EACA,UAAA;AACF;AACI;EACE,kBAAA;AACN;AAEE;EACE,gBAAA;EACA,gBAAA;EACA,cAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,gBAAA;EACA,eAAA;AAAJ;;AAIA;EACE,kBAAA;EACA,YAAA;EACA,YAAA;AADF;;AAIA;EACE,mBAAA;EACA,YAAA;EACA,aAAA;EACA,wBAAA;EACA,yBAAA;EACA,kBAAA;EACA,cAAA;EACA,QAAA;AADF;AAEE;EACE,iBAAA;EACA,oBAAA;EACA,mBAAA;EACA,WAAA;EACA,YAAA;AAAJ;;AAIA;EACE,uBAAA;EACA,aAAA;EACA,kBAAA;EACA,UAAA;AADF;AAEE;EACE,iBAAA;EACA,cAAA;EACA,YAAA;EACA,kBAAA;AAAJ;AAEE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;AAAJ;AAEE;EACE,kBAAA;EACA,YAAA;EACA,aAAA;EACA,WAAA;EACA,UAAA;AAAJ;AACI;EACE,eAAA;EACA,iBAAA;EACA,yBAAA;AACN;AACI;EACE,gBAAA;EACA,iBAAA;EACA,eAAA;AACN;AACI;EACE,gBAAA;EACA,aAAA;EACA,mBAAA;AACN;AAAM;EACE,SAAA;EACA,WAAA;EACA,yBAAA;AAER;AAAM;EACE,cAAA;EACA,gBAAA;AAER;AACI;EACE,aAAA;EACA,gBAAA;EACA,8BAAA;AACN;AAAM;EACE,WAAA;EACA,kBAAA;EACA,mBAAA;EACA,yBAAA;EACA,aAAA;EACA,aAAA;EACA,uBAAA;EACA,mBAAA;EACA,eAAA;AAER;;AAIA;EACE,yBAAA;EACA,aAAA;EACA,UAAA;AADF;AAEE;EACE,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,UAAA;AAAJ;;AAIA;EACE,YAAA;EACA,YAAA;AADF;AAEE;EACE,eAAA;EACA,yBAAA;EACA,gBAAA;AAAJ;AAEE;EACE,eAAA;EACA,iBAAA;EACA,gBAAA;AAAJ;;AAIA;EACE,aAAA;EACA,uBAAA;AADF;AAEE;EACE,cAAA;EACA,iBAAA;EACA,YAAA;EACA,kBAAA;EACA,aAAA;EACA,8BAAA;AAAJ;AACI;EACE,aAAA;EACA,sBAAA;EACA,8BAAA;AACN;;AAIA;EACE,gBAAA;AADF;AAEE;EACE,eAAA;AAAJ;AAEE;EACE,gBAAA;AAAJ;;AAIA;EACE,YAAA;AADF;AAEE;EACE,gBAAA;AAAJ;AACI;EACE,eAAA;AACN;AACI;EACE,gBAAA;AACN;AAGI;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,kBAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,cAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;AADN;AAII;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,YAAA;EACA,YAAA;EACA,yBAAA;EACA,mBAAA;EACA,aAAA;EACA,iBAAA;EACA,iBAAA;EACA,eAAA;EACA,eAAA;EACA,cAAA;EACA,gBAAA;EACA,+BAAA;EACA,eAAA;EACA,iBAAA;AAFN;;AAOA;EACE,cAAA;EACA,YAAA;EACA,YAAA;EACA,eAAA;AAJF;;AAOA;EAII;IACE,aAAA;IACA,yBAAA;EAPJ;EAUE;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;EARJ;EAWM;IACE,kBAAA;EATR;EAaI;IACE,gBAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;IACA,yBAAA;IACA,gBAAA;EAXN;EAcI;IACE,gBAAA;IACA,eAAA;EAZN;EAiBA;IACE,gBAAA;EAfF;AACF;AAkBA;EAEI;IACE,iBAAA;EAjBJ;EAmBE;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;EAjBJ;EAkBI;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;EAhBN;EAkBI;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;EAhBN;EAkBI;IACE,gBAAA;IACA,aAAA;IACA,mBAAA;EAhBN;EAiBM;IACE,SAAA;IACA,WAAA;IACA,yBAAA;EAfR;EAiBM;IACE,cAAA;IACA,gBAAA;EAfR;EAkBI;IACE,aAAA;IACA,gBAAA;IACA,8BAAA;EAhBN;EAiBM;IACE,mBAAA;IACA,yBAAA;IACA,iBAAA;IACA,eAAA;EAfR;AACF;AAqBA;EAEE;IACE,mBAAA;EApBF;EAqBE;IACE,gBAAA;EAnBJ;EAoBI;IACE,WAAA;IACA,YAAA;EAlBN;EAoBI;IACE,eAAA;IACA,iBAAA;EAlBN;EAqBE;IACE,eAAA;IACA,iBAAA;EAnBJ;EAyBE;IACE,aAAA;IACA,yBAAA;EAvBJ;EA0BE;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;EAxBJ;EA2BM;IACE,kBAAA;EAzBR;EA6BI;IACE,eAAA;IACA,iBAAA;EA3BN;EAiCA;IACE,gBAAA;EA/BF;EAgCE;IACE,YAAA;EA9BJ;EAiCA;IACE,YAAA;EA/BF;EAiCA;IACE,aAAA;EA/BF;EAkCA;IACE,aAAA;EAhCF;EAiCE;IACE,iBAAA;EA/BJ;EAiCE;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,aAAA;EA/BJ;EAiCE;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;EA/BJ;EAgCI;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;EA9BN;EAgCI;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;EA9BN;AACF;AAmCA;EACE;IACE,aAAA;EAjCF;EAkCE;IACE,gBAAA;IACA,yBAAA;EAhCJ;EAkCE;IACE,gBAAA;IACA,gBAAA;IACA,iBAAA;EAhCJ;EAmCM;IACE,kBAAA;IACA,YAAA;EAjCR;EAqCI;IACE,eAAA;IACA,iBAAA;EAnCN;EAyCI;IACE,YAAA;EAvCN;EA0CE;IACE,YAAA;EAxCJ;EA4CA;IACE,aAAA;EA1CF;EA2CE;IACE,gBAAA;EAzCJ;EA2CE;IACE,kBAAA;IACA,SAAA;IACA,UAAA;IACA,aAAA;EAzCJ;EA2CE;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,WAAA;IACA,UAAA;EAzCJ;EA0CI;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;EAxCN;EA0CI;IACE,gBAAA;IACA,iBAAA;IACA,eAAA;EAxCN;EA0CI;IACE,aAAA;IACA,gBAAA;IACA,uBAAA;EAxCN;EAyCM;IACE,mBAAA;IACA,yBAAA;IACA,cAAA;IACA,eAAA;IACA,iBAAA;EAvCR;AACF;AA6CA;EAEE;IACE,kBAAA;IACA,8BAAA;IACA,aAAA;IACA,aAAA;EA5CF;EA8CI;IACE,eAAA;IACA,iBAAA;EA5CN;EAiDA;IACE,aAAA;EA/CF;EAgDE;IACE,aAAA;EA9CJ;EAgDE;IACE,WAAA;IACA,QAAA;IACA,eAAA;EA9CJ;EA+CI;IACE,kBAAA;EA7CN;EA+CI;IACE,kBAAA;EA7CN;AACF;AAkDA;EAEE;IACE,kBAAA;IACA,8BAAA;IACA,aAAA;IACA,aAAA;EAjDF;EAmDI;IACE,eAAA;IACA,iBAAA;EAjDN;EAoDE;IACE,eAAA;IACA,iBAAA;EAlDJ;EAsDA;IACE,aAAA;EApDF;EAqDE;IACE,WAAA;IAEA,kBAAA;EApDJ;EAsDE;IACE,gBAAA;IACA,eAAA;IAEA,aAAA;EArDJ;EAwDM;IACE,WAAA;IACA,YAAA;IACA,iBAAA;EAtDR;EA0DI;IACE,gBAAA;IACA,cAAA;IACA,iBAAA;IACA,WAAA;EAxDN;EA2DI;IACE,gBAAA;IACA,eAAA;IACA,YAAA;IACA,YAAA;EAzDN;EA8DA;IACE,kBAAA;IACA,YAAA;IACA,aAAA;IACA,UAAA;IACA,aAAA;EA5DF;EA6DE;IACE,gBAAA;IACA,aAAA;EA3DJ;EAgEA;IACE,cAAA;IACA,kBAAA;IACA,kBAAA;IACA,wBAAA;IACA,YAAA;IACA,aAAA;IACA,QAAA;IACA,YAAA;EA9DF;EA+DE;IACE,kBAAA;EA7DJ;EAiEA;IACE,kBAAA;IACA,YAAA;IACA,QAAA;IACA,aAAA;IACA,YAAA;EA/DF;EAgEE;IACE,YAAA;IACA,aAAA;EA9DJ;EAkEA;IACE,kBAAA;IACA,aAAA;IACA,WAAA;EAhEF;EAmEA;IACE,cAAA;IACA,kBAAA;IACA,4BAAA;IACA,UAAA;IACA,WAAA;IACA,YAAA;IACA,iBAAA;EAjEF;EAoEA;IACE,aAAA;IACA,gBAAA;IACA,kBAAA;EAlEF;EAmEE;IACE,WAAA;EAjEJ;EAmEE;IAEE,WAAA;IACA,YAAA;EAlEJ;EAoEE;IACE,gBAAA;IACA,gBAAA;IACA,eAAA;IACA,aAAA;EAlEJ;EAmEI;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EAjEN;EAmEI;IACE,YAAA;IACA,gBAAA;IACA,eAAA;IACA,gBAAA;IACA,iBAAA;IACA,gBAAA;EAjEN;EAmEI;IACE,aAAA;IACA,sBAAA;IACA,uBAAA;IACA,gBAAA;EAjEN;EAkEM;IACE,aAAA;IACA,uBAAA;IACA,mBAAA;IACA,aAAA;IACA,eAAA;IACA,mBAAA;IACA,yBAAA;IACA,eAAA;EAhER;EAqEA;IACE,aAAA;EAnEF;EAoEE;IACE,YAAA;IACA,gBAAA;IACA,8BAAA;IACA,kBAAA;EAlEJ;EAoEM;IACE,YAAA;IACA,aAAA;EAlER;EAsEE;IACE,WAAA;IACA,gBAAA;EApEJ;EAqEI;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;IACA,gBAAA;EAnEN;EAqEI;IACE,eAAA;IACA,iBAAA;IACA,gBAAA;EAnEN;EAuEA;IACE,aAAA;EArEF;EAsEE;IACE,gBAAA;IACA,kBAAA;IACA,8BAAA;EApEJ;EAwEA;IACE,gBAAA;IACA,mBAAA;EAtEF;EAuEE;IACE,yBAAA;IACA,eAAA;IACA,iBAAA;IACA,gBAAA;EArEJ;EAyEA;IACE,WAAA;EAvEF;EAwEE;IACE,gBAAA;EAtEJ;EAuEI;IACE,eAAA;IACA,iBAAA;IACA,yBAAA;EArEN;EAuEI;IACE,gBAAA;IACA,eAAA;IACA,iBAAA;EArEN;EAwEE;IACE,gBAAA;EAtEJ;EAwEE;IACE,gBAAA;IACA,YAAA;IACA,gBAAA;EAtEJ;AACF","sourcesContent":[".main {\n  overflow: hidden;\n}\n\n.extra_row {\n  padding: 200px 50px;\n  display: flex;\n  column-gap: 5vw;\n  align-items: center;\n  justify-content: space-between;\n  border-bottom: 2px solid #EEEEEE;\n  &_leftSide {\n    display: flex;\n    align-items: center;\n    column-gap: 24px;\n    p {\n      font-weight: 400;\n      font-size: 20.85px;\n      line-height: 23.8px;\n    }\n  }\n  &_rightSide {\n    font-size: 36px;\n    line-height: 44px;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n}\n\n.cvetochek {\n  position: absolute;\n  top: -50%;\n  right: 40%;\n  z-index: 1;\n}\n\n.cvetochek2 {\n  position: absolute;\n  z-index: 1;\n  right: 0;\n}\n\n.frame55 {\n  display: none;\n}\n\n.first_row {\n  background-color: #3D9246;\n  height: 1024px;\n  z-index: 1;\n  &_content {\n    margin: 0 auto;\n    max-width: 1440px;\n    height: 100%;\n    position: relative;\n    z-index: 2;\n    padding: 80px 40px 0 50px;\n  }\n}\n\n.girls_reading {\n  position: absolute;\n  right: 0;\n}\n\n.tamyr {\n  position: absolute;\n  top: 200px;\n  &_emblems {\n    img {\n      margin-right: 34px;\n    }\n  }\n  &_title {\n    max-width: 821px;\n    margin-top: 60px;\n    color: #FFFFFF;\n    font-size: 48px;\n    line-height: 57px;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n  &_button {\n    margin-top: 60px;\n    cursor: pointer;\n  }\n}\n\n.mosque {\n  position: absolute;\n  bottom: 80px;\n  right: 452px;\n}\n\n.moon {\n  border-radius: 25px;\n  width: 345px;\n  height: 345px;\n  padding: 6px 3px 3px 3px;\n  background-color: #FFB765;\n  position: absolute;\n  bottom: -120px;\n  right: 0;\n  img {\n    object-fit: cover;\n    object-position: 50%;\n    border-radius: 25px;\n    width: 100%;\n    height: 100%;\n  }\n}\n\n.second_row {\n  background-color: white;\n  height: 865px;\n  position: relative;\n  z-index: 2;\n  &_content {\n    max-width: 1440px;\n    margin: 0 auto;\n    height: 100%;\n    position: relative;\n  }\n  &_image {\n    position: absolute;\n    bottom: 0;\n    right: 55%;\n  }\n  &_info {\n    position: absolute;\n    width: 621px;\n    height: 390px;\n    right: 50px;\n    top: 238px;\n    & > h1 {\n      font-size: 36px;\n      line-height: 44px;\n      text-transform: uppercase;\n    }\n    & > p {\n      margin-top: 20px;\n      line-height: 22px;\n      font-size: 18px;\n    }\n    .download {\n      margin-top: 56px;\n      display: flex;\n      align-items: center;\n      &_line {\n        flex: 1;\n        height: 1px;\n        background-color: #CACACA;\n      }\n      &_sign {\n        margin: 0 25px;\n        font-weight: 500;\n      }\n    }\n    .buttons {\n      display: flex;\n      margin-top: 56px;\n      justify-content: space-between;\n      &_button {\n        width: 100%;\n        margin-right: 20px;\n        border-radius: 12px;\n        background-color: #3D9246;\n        padding: 11px;\n        display: flex;\n        justify-content: center;\n        align-items: center;\n        cursor: pointer;\n      }\n    }\n  }\n}\n\n.third_row {\n  background-color: #3D9246;\n  height: 557px;\n  z-index: 1;\n  &_content {\n    margin: 0 auto;\n    max-width: 1440px;\n    height: 100%;\n    position: relative;\n    padding: 93px 50px;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    z-index: 2;\n  }\n}\n\n.about {\n  width: 620px;\n  color: white;\n  & > h1 {\n    font-size: 36px;\n    text-transform: uppercase;\n    font-weight: 500;\n  }\n  & > p {\n    font-size: 18px;\n    line-height: 22px;\n    margin-top: 20px;\n  }\n}\n\n.fourth_row {\n  height: 561px;\n  background-color: white;\n  &_content {\n    margin: 0 auto;\n    max-width: 1440px;\n    height: 100%;\n    padding: 55px 50px;\n    display: flex;\n    justify-content: space-between;\n    & > div {\n      display: flex;\n      flex-direction: column;\n      justify-content: space-between;\n    }\n  }\n}\n\n.contacts {\n  font-weight: 500;\n  &_header {\n    font-size: 24px;\n  }\n  &_content {\n    margin-top: 20px;\n  }\n}\n\n.write_us {\n  width: 445px;\n  &_1strow {\n    font-weight: 500;\n    &_header {\n      font-size: 24px;\n    }\n    &_sign {\n      margin-top: 20px;\n    }\n  }\n  &_form {\n    &_mail {\n      width: 100%;\n      outline: none;\n      padding: 20px;\n      margin-bottom: 8px;\n      border: none;\n      background-color: #EEEEEE;\n      border-radius: 12px;\n      color: #575757;\n      font-weight: 500;\n      font-size: 18px;\n      line-height: 22px;\n    }\n\n    &_message {\n      width: 100%;\n      outline: none;\n      padding: 20px;\n      border: none;\n      resize: none;\n      background-color: #EEEEEE;\n      border-radius: 12px;\n      height: 168px;\n      max-height: 168px;\n      min-height: 168px;\n      max-width: 100%;\n      min-width: 100%;\n      color: #575757;\n      font-weight: 500;\n      font-family: Roboto, sans-serif;\n      font-size: 18px;\n      line-height: 22px;\n    }\n  }\n}\n\n.send_button {\n  margin: 0 auto;\n  width: 278px;\n  height: 56px;\n  cursor: pointer;\n}\n\n@media screen and (max-width: 1400px) {\n\n  .first_row {\n\n    &_content {\n      display: flex;\n      padding: 80px 20px 0 25px;\n    }\n\n    .tamyr {\n      position: static;\n      max-width: 800px;\n      margin-top: 100px;\n\n      &_emblems {\n        img {\n          margin-right: 34px;\n        }\n      }\n\n      &_title {\n        margin-top: 60px;\n        color: #FFFFFF;\n        font-size: 40px;\n        line-height: 57px;\n        text-transform: uppercase;\n        font-weight: 500;\n      }\n\n      &_button {\n        margin-top: 60px;\n        cursor: pointer;\n      }\n    }\n  }\n\n  .girls_reading {\n    position: static;\n  }\n}\n\n@media screen and (max-width: 1300px) {\n  .second_row {\n    &_content {\n      max-width: 1300px;\n    }\n    &_info {\n      position: absolute;\n      width: 500px;\n      height: 300px;\n      right: 50px;\n      top: 208px;\n      & > h1 {\n        font-size: 30px;\n        line-height: 40px;\n        text-transform: uppercase;\n      }\n      & > p {\n        margin-top: 15px;\n        line-height: 20px;\n        font-size: 16px;\n      }\n      .download {\n        margin-top: 50px;\n        display: flex;\n        align-items: center;\n        &_line {\n          flex: 1;\n          height: 1px;\n          background-color: #CACACA;\n        }\n        &_sign {\n          margin: 0 20px;\n          font-weight: 500;\n        }\n      }\n      .buttons {\n        display: flex;\n        margin-top: 40px;\n        justify-content: space-between;\n        &_button {\n          border-radius: 12px;\n          background-color: #3D9246;\n          padding: 3px 57px;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 1100px) {\n\n  .extra_row {\n    padding: 140px 42px;\n    &_leftSide {\n      column-gap: 16px;\n      img {\n        width: 76px;\n        height: 80px;\n      }\n      p {\n        font-size: 14px;\n        line-height: 16px;\n      }\n    }\n    &_rightSide {\n      font-size: 24px;\n      line-height: 28px;\n    }\n  }\n\n  .first_row {\n\n    &_content {\n      display: flex;\n      padding: 40px 20px 0 25px;\n    }\n\n    .tamyr {\n      position: static;\n      max-width: 700px;\n      margin-top: 100px;\n\n      &_emblems {\n        img {\n          margin-right: 34px;\n        }\n      }\n\n      &_title {\n        font-size: 36px;\n        line-height: 44px;\n      }\n\n    }\n  }\n\n  .girls_reading {\n    position: static;\n    img {\n      width: 450px;\n    }\n  }\n  .mosque {\n    right: 100px;\n  }\n  .moon {\n    display: none;\n  }\n\n  .second_row {\n    height: 650px;\n    &_content {\n      max-width: 1100px;\n    }\n    &_image {\n      position: absolute;\n      bottom: 0;\n      right: 60%;\n      height: 700px;\n    }\n    &_info {\n      position: absolute;\n      width: 500px;\n      height: 300px;\n      right: 30px;\n      top: 150px;\n      & > h1 {\n        font-size: 24px;\n        line-height: 35px;\n        text-transform: uppercase;\n      }\n      & > p {\n        margin-top: 15px;\n        line-height: 18px;\n        font-size: 14px;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 957px) {\n  .first_row {\n    height: 800px;\n    &_content {\n      max-width: 957px;\n      padding: 40px 15px 0 20px;\n    }\n    .tamyr {\n      position: static;\n      max-width: 500px;\n      margin-top: 100px;\n\n      &_emblems {\n        img {\n          margin-right: 24px;\n          width: 130px;\n        }\n      }\n\n      &_title {\n        font-size: 26px;\n        line-height: 36px;\n      }\n\n    }\n\n    .girls_reading {\n      img {\n        width: 400px;\n      }\n    }\n    .mosque {\n      bottom: 30px;\n    }\n  }\n\n  .second_row {\n    height: 500px;\n    &_content {\n      max-width: 957px;\n    }\n    &_image {\n      position: absolute;\n      bottom: 0;\n      right: 60%;\n      height: 550px;\n    }\n    &_info {\n      position: absolute;\n      width: 450px;\n      height: 300px;\n      right: 10px;\n      top: 100px;\n      & > h1 {\n        font-size: 24px;\n        line-height: 35px;\n        text-transform: uppercase;\n      }\n      & > p {\n        margin-top: 15px;\n        line-height: 18px;\n        font-size: 14px;\n      }\n      .buttons {\n        display: flex;\n        margin-top: 40px;\n        justify-content: center;\n        &_button {\n          border-radius: 10px;\n          background-color: #3D9246;\n          padding: 0 5vw;\n          cursor: pointer;\n          margin-right: 1vw;\n        }\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 805px) {\n\n  .extra_row {\n    padding: 80px 40px;\n    flex-direction: column-reverse;\n    column-gap: 0;\n    row-gap: 32px;\n    &_leftSide {\n      p {\n        font-size: 16px;\n        line-height: 20px;\n      }\n    }\n  }\n\n  .second_row {\n    height: 450px;\n    &_image {\n      display: none;\n    }\n    &_info {\n      width: 100%;\n      right: 0;\n      padding: 0 30px;\n      & > h1 {\n        text-align: center;\n      }\n      & > p {\n        text-align: center;\n      }\n    }\n  }\n}\n\n@media screen and (max-width: 600px) {\n\n  .extra_row {\n    padding: 48px 23px;\n    flex-direction: column-reverse;\n    column-gap: 0;\n    row-gap: 16px;\n    &_leftSide {\n      p {\n        font-size: 12px;\n        line-height: 14px;\n      }\n    }\n    &_rightSide {\n      font-size: 20px;\n      line-height: 24px;\n    }\n  }\n\n  .first_row {\n    height: 677px;\n    &_content {\n      width: 100%;\n      //max-width: 375px;\n      padding: 48px 20px;\n    }\n    .tamyr {\n      position: static;\n      max-width: 100%;\n      //max-width: 330px;\n      margin-top: 0;\n\n      &_emblems {\n        img {\n          width: 78px;\n          height: 78px;\n          margin-right: 5px;\n        }\n      }\n\n      &_title {\n        margin-top: 24px;\n        font-size: 7vw;\n        line-height: 28px;\n        width: 100%;\n      }\n\n      &_button {\n        margin-top: 24px;\n        cursor: pointer;\n        width: 201px;\n        height: 36px;\n      }\n    }\n  }\n\n  .girls_reading {\n    position: absolute;\n    width: 204px;\n    height: 204px;\n    left: 20px;\n    bottom: 100px;\n    img {\n      max-width: 204px;\n      height: 204px;\n    }\n    //display: none;\n  }\n\n  .moon {\n    display: block;\n    position: absolute;\n    border-radius: 8px;\n    padding: 4px 2px 2px 2px;\n    width: 150px;\n    height: 150px;\n    top: 70%;\n    right: -70px;\n    img {\n      border-radius: 8px;\n    }\n  }\n\n  .mosque {\n    position: absolute;\n    right: -45px;\n    top: 45%;\n    height: 142px;\n    width: 142px;\n    img {\n      width: 142px;\n      height: 142px;\n    }\n  }\n\n  .frame55_wrapper {\n    position: relative;\n    height: 400px;\n    width: 100%;\n  }\n\n  .frame55 {\n    display: block;\n    position: absolute;\n    border-radius: 20px 20px 0 0;\n    top: -15px;\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n\n  .second_row {\n    height: 890px;\n    max-width: 100vw;\n    position: relative;\n    &_image {\n      width: 100%;\n    }\n    &_content {\n      //position: relative;\n      width: 100%;\n      height: 100%;\n    }\n    &_info {\n      margin-top: 30px;\n      position: static;\n      padding: 0 20px;\n      height: 490px;\n      h1 {\n        font-weight: 500;\n        font-size: 20px;\n        line-height: 24px;\n        text-align: left;\n      }\n      p {\n        color: black;\n        font-weight: 400;\n        font-size: 16px;\n        margin-top: 12px;\n        line-height: 20px;\n        text-align: left;\n      }\n      .buttons {\n        display: flex;\n        flex-direction: column;\n        justify-content: center;\n        margin-top: 30px;\n        &_button {\n          display: flex;\n          justify-content: center;\n          align-items: center;\n          padding: 11px;\n          margin-top: 6px;\n          border-radius: 12px;\n          background-color: #3D9246;\n          cursor: pointer;\n        }\n      }\n    }\n  }\n  .third_row {\n    height: 600px;\n    &_content {\n      height: 100%;\n      max-width: 375px;\n      flex-direction: column-reverse;\n      padding: 48px 20px;\n      .image {\n        img {\n          width: 162px;\n          height: 162px;\n        }\n      }\n    }\n    .about {\n      width: 100%;\n      margin-top: 25px;\n      & > h1 {\n        font-size: 20px;\n        line-height: 24px;\n        text-transform: uppercase;\n        font-weight: 500;\n      }\n      & > p {\n        font-size: 16px;\n        line-height: 20px;\n        margin-top: 10px;\n      }\n    }\n  }\n  .fourth_row {\n    height: 766px;\n    &_content {\n      max-width: 375px;\n      padding: 48px 20px;\n      flex-direction: column-reverse;\n    }\n  }\n\n  .contacts {\n    margin-top: 48px;\n    margin-bottom: 24px;\n    &_header {\n      text-transform: uppercase;\n      font-size: 20px;\n      line-height: 24px;\n      font-weight: 500;\n    }\n  }\n\n  .write_us {\n    width: 100%;\n    &_1strow {\n      font-weight: 500;\n      &_header {\n        font-size: 20px;\n        line-height: 24px;\n        text-transform: uppercase;\n      }\n      &_sign {\n        margin-top: 12px;\n        font-size: 16px;\n        line-height: 20px;\n      }\n    }\n    &_form {\n      margin-top: 24px;\n    }\n    .send_button {\n      max-width: 181px;\n      height: 36px;\n      margin-top: 24px;\n    }\n  }\n}\n\n//.second_row {\n//  height: 1000px;\n//  &_content {\n//    padding: 0;\n//    width: 100%;\n//\n//  }\n//  &_info {\n//    width: 100%;\n//    top: 600px;\n//    right: 0;\n//    padding: 50px;\n//  }\n//  &_image {\n//    border-radius: 0;\n//    top: 0;\n//    right: 0;\n//    width: 100%;\n//  }\n//}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"main": `page_main__NOXsH`,
	"extra_row": `page_extra_row__GOk-m`,
	"extra_row_leftSide": `page_extra_row_leftSide__-LzXB`,
	"extra_row_rightSide": `page_extra_row_rightSide__qbome`,
	"cvetochek": `page_cvetochek__8aV7s`,
	"cvetochek2": `page_cvetochek2__-j-PL`,
	"frame55": `page_frame55__+yB1u`,
	"first_row": `page_first_row__zWz7E`,
	"first_row_content": `page_first_row_content__LOeo+`,
	"girls_reading": `page_girls_reading__CD2dB`,
	"tamyr": `page_tamyr__loepg`,
	"tamyr_emblems": `page_tamyr_emblems__Vk9q+`,
	"tamyr_title": `page_tamyr_title__Zg2Kz`,
	"tamyr_button": `page_tamyr_button__EiHEL`,
	"mosque": `page_mosque__OKjgY`,
	"moon": `page_moon__WUBfS`,
	"second_row": `page_second_row__YJM3x`,
	"second_row_content": `page_second_row_content__YbDli`,
	"second_row_image": `page_second_row_image__XGW8C`,
	"second_row_info": `page_second_row_info__XVEpP`,
	"download": `page_download__qdOHL`,
	"download_line": `page_download_line__eP9zR`,
	"download_sign": `page_download_sign__vjWIL`,
	"buttons": `page_buttons__wvcaR`,
	"buttons_button": `page_buttons_button__tix-b`,
	"third_row": `page_third_row__4Gs07`,
	"third_row_content": `page_third_row_content__0oFBD`,
	"about": `page_about__A6lpY`,
	"fourth_row": `page_fourth_row__Yvg99`,
	"fourth_row_content": `page_fourth_row_content__OlBYY`,
	"contacts": `page_contacts__-oWcx`,
	"contacts_header": `page_contacts_header__Ytwh4`,
	"contacts_content": `page_contacts_content__-BU8P`,
	"write_us": `page_write_us__y39UB`,
	"write_us_1strow": `page_write_us_1strow__vagMP`,
	"write_us_1strow_header": `page_write_us_1strow_header__DFdV6`,
	"write_us_1strow_sign": `page_write_us_1strow_sign__EapqV`,
	"write_us_form_mail": `page_write_us_form_mail__IMpcB`,
	"write_us_form_message": `page_write_us_form_message__lN2Wh`,
	"send_button": `page_send_button__ciNME`,
	"frame55_wrapper": `page_frame55_wrapper__5nwxc`,
	"image": `page_image__GzZGF`,
	"write_us_form": `page_write_us_form__hoAqh`
};
export default ___CSS_LOADER_EXPORT___;
